
export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-purple-600 rounded-lg flex items-center justify-center">
                <i className="ri-shield-keyhole-line text-white text-xl"></i>
              </div>
              <span className="text-2xl font-bold">IMPRIME VPN</span>
            </div>
            <p className="text-gray-400 mb-4 leading-relaxed">
              Protecting your online privacy and security with advanced VPN technology. Browse safely, access global content, and stay anonymous online.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-twitter-x-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-instagram-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4 whitespace-nowrap">Quick Links</h3>
            <ul className="space-y-2">
              <li><a href="#features" className="text-gray-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap">Features</a></li>
              <li><a href="#how-it-works" className="text-gray-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap">How It Works</a></li>
              <li><a href="#security" className="text-gray-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap">Security</a></li>
              <li><a href="#contact" className="text-gray-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap">Contact</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4 whitespace-nowrap">Contact Info</h3>
            <ul className="space-y-2 text-gray-400">
              <li className="flex items-start space-x-2">
                <i className="ri-map-pin-line mt-1"></i>
                <span>CALLE 1 N 9 33<br />POPAYAN, Colombia<br />190001</span>
              </li>
              <li className="flex items-center space-x-2">
                <i className="ri-mail-line"></i>
                <a href="mailto:support@imprimeedicionesltda.com" className="hover:text-white transition-colors cursor-pointer">support@imprimeedicionesltda.com</a>
              </li>
              <li className="flex items-center space-x-2">
                <i className="ri-phone-line"></i>
                <a href="tel:+19522439221" className="hover:text-white transition-colors cursor-pointer">+1 952-243-9221</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm mb-4 md:mb-0">
            © {currentYear} IMPRIME EDICIONES LTDA. All rights reserved.
          </p>
          <div className="flex items-center space-x-6">
            <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer whitespace-nowrap">Privacy Policy</a>
            <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer whitespace-nowrap">Terms of Service</a>
            <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer whitespace-nowrap">Powered by Readdy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
